var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"a8b8c26938d6dd6a192d4f583f211c85d4652feb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nextjs@gie-perdana"]={id:"a8b8c26938d6dd6a192d4f583f211c85d4652feb"};
      